/* eslint-disable */
import React, { useState, useEffect } from "react";
import * as API from "../../framework/API/api";
import { ENTITYNAME, FILEURL, PLANNINGTYPE, SCHEDULETYPE } from "../../framework/constant/constant";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { utility } from "../../framework/utility/utilityProvider";
import { toast } from 'react-toastify';
import { useTranslation } from "../../locale/useTranslation";
import { Grid, GridColumn as Column, GridNoRecords } from "@progress/kendo-react-grid";
import ActionButton from "../../framework/forms/helpercomponents/buttons/ActionButton";
import { TimeCell } from "../../framework/forms/helpercomponents/CustomGridCells/TimeCell";
import RoundButton from "../../framework/forms/helpercomponents/buttons/RoundButton";


export const MamAssetReport = () => {

    const blankDataItem = {
        // ScheduleDate: "",
        MediaCategory: {},
    }

    const lang = useTranslation();
    const [dataItem, setDataItem] = useState(blankDataItem);
    const [gridData, setGridData] = useState([]);
    const [mediaCategory, setMediaCategory] = useState([]);
    const [loadingStatus, setLoadingStatus] = useState(lang.no_record_found_error_message);

    useEffect(() => {
        loadcombo();
    }, []);

    const loadcombo = async () => {
        var mediaCategoryRes = await API.getDataLookup(ENTITYNAME.MediaCategory, { sort: { SID: 1 } });
        setMediaCategory(mediaCategoryRes.data);
    }

    const onChange = (e) => {
        setDataItem({ ...dataItem, [e.target.name]: e.target.value });
    };

    const isValid = () => {
        // if (!utility.isValidDate(dataItem.ScheduleDate)) {
        //     toast.error(`${lang.please_select_schedule_date_error_message}`, {
        //         position: toast.POSITION.TOP_RIGHT
        //     });
        //     return false;
        // }
        if (Object.keys(dataItem.MediaCategory).length == 0) {
            toast.error(`${lang.please_select_channel_error_message}`, {
                position: toast.POSITION.TOP_RIGHT
            });
            return false;
        }
        return true
    }

    const loadData = async () => {
        if (!isValid()) return;

        setLoadingStatus(lang.data_loading_error_message);

        const payload = {
            MediaCategory: dataItem.MediaCategory.SID
        };

        const resMediaData = await API.getData(ENTITYNAME.MediaEpisode, {
            query: ["MediaCategory.SID", "=", payload.MediaCategory]
        });

        if (!resMediaData.data || resMediaData.data.length === 0) {
            toast.info(`${lang.no_data_found_error_message}`, {
                position: toast.POSITION.TOP_RIGHT
            });
            setGridData([]);
            setLoadingStatus(`${lang.no_record_found_error_message}`);
            return;
        }

        const resMediaAssets = await API.getData(ENTITYNAME.MediaMamAssets);

        const tempArray = resMediaData.data.map((mediaItem) => {
            const matchingAsset = resMediaAssets.data.find(
                (asset) => asset.AssetId === mediaItem.AssetId
            );

            let status = "MISSING";
            if (matchingAsset && matchingAsset._id) {
                status = matchingAsset.ActualDuration !== mediaItem.Duration
                    ? "DURATION MISMATCH"
                    : "READY";
            }
            return {
                Title: mediaItem.Title,
                MediaId: mediaItem.AssetId,
                Type: mediaItem.MediaCategory?.Description || "",
                Duration: mediaItem.Duration,
                Status: status,
                MamDuration: matchingAsset?.ActualDuration ?? 0
            };
        });
        setGridData(tempArray);
        setLoadingStatus(`${lang.no_record_found_error_message}`);
    };

    const downloadExcel = async () => {

        if (gridData.length == 0) {
            return;
        }

        console.log(gridData);

        let storeData = gridData.map(x => {
            return {
                ...x,
                Duration: utility.convertMilisecondsToStringWithFrames(x.Duration),
                MamDuration: utility.convertMilisecondsToStringWithFrames(x.MamDuration)
            }
        })
        let res = await API.exportCSV(storeData);
        if (res.success) {
            window.open(FILEURL.BASEURL + 'downloadReport/' + res.data)
            toast.success(`${lang.successfully_download_success_message}`, {
                position: toast.POSITION.TOP_RIGHT
            });
        }
        else {
            toast.error(res.message, {
                position: toast.POSITION.TOP_RIGHT
            });
        }
    }

    return (<>
        <h1 className="page-title txt-color-bludeDark">
            <i
                className="fa fa-table marlr"
                style={{ fontSize: "20px", color: "GrayText" }}
            ></i>
            <span>{lang.mam_asset_report_page_breadcrumb}</span>
        </h1>
        <div className="row m-1">
            <div className="col-12">
                <div className="row">
                    {/* <div className="col-3">
                        <label className="form-label">{lang.schedule_date_label} *</label>
                        <input type="date" className="form-control form-control-sm" name="ScheduleDate" value={dataItem.ScheduleDate} onChange={onChange} />
                    </div> */}
                    <div className="col-3">
                        <label className="form-label">{lang.media_category_label} *</label>
                        <DropDownList
                            data={mediaCategory}
                            textField="Description"
                            dataItemKey="SID"
                            name="MediaCategory"
                            onChange={onChange}
                            value={dataItem.MediaCategory}
                        />
                    </div>
                    <div className="col mt-4">
                        <ActionButton name={lang.show_button_text} onClick={loadData} />
                        <RoundButton icon='download' onClick={() => downloadExcel()} style={{ marginLeft: '10px' }} title={lang.download_button_tooltip} />
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-12">
                        <Grid data={gridData} style={{ height: '70vh' }}>
                            <GridNoRecords>{loadingStatus}</GridNoRecords>
                            <Column field="Title" title={lang.title_column} />
                            <Column field="MediaId" title={lang.media_id_column} />
                            <Column field="Type" title={lang.type_column} />
                            <Column field="Duration" title={lang.schedule_duration_column} cell={TimeCell} />
                            <Column field="MamDuration" title={lang.mam_duration_column} cell={TimeCell} />
                            <Column field="Status" title={lang.status_column} />
                        </Grid>
                    </div>
                </div>
            </div>
        </div>

    </>)
}
export default MamAssetReport;